module.exports = __webpack_public_path__ + "images/oth-promo-banner-mobile-bg.jpg";